// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton_root__1T0-1"};